module.exports = __webpack_public_path__ + "images/526b134aa55cdf112689e3346b37a8f5.gif";